import { Insurance, InsuranceDocument, InsuranceNote, InsuranceStatus } from '@centecomm/portal-service';

export enum InsuranceActions {
    ADD_OCCUPANT_INSURANCES = 'INSURANCE_ADD_OCCUPANT_INSURANCES',
    ADD_INSURANCE = 'INSURANCE_ADD_INSURANCE',
    EDIT_COVERAGE_DATES = 'INSURANCE_EDIT_COVERAGE_DATES',
    EDIT_INSURANCE_STATUS = 'INSURANCE_EDIT_INSURANCE_STATUS',
    ADD_INSURANCE_DOCUMENTS = 'INSURANCE_ADD_INSURANCE_DOCUMENTS',
    ADD_INSURANCE_DOCUMENT = 'INSURANCE_ADD_INSURANCE_DOCUMENT',
    REMOVE_INSURANCE_DOCUMENT = 'INSURANCE_REMOVE_INSURANCE_DOCUMENT',
    ADD_INSURANCE_NOTES = 'INSURANCE_ADD_INSURANCE_NOTES',
    ADD_INSURANCE_NOTE = 'INSURANCE_ADD_INSURANCE_NOTE',
    ADD_PENDING_DOCUMENTS = 'INSURANCE_ADD_PENDING_DOCUMENTS',
    ADD_PENDING_DOCUMENT = 'INSURANCE_ADD_PENDING_DOCUMENT',
    REMOVE_PENDING_DOCUMENT = 'INSURANCE_REMOVE_PENDING_DOCUMENT',
    REMOVE_PENDING_DOCUMENTS = 'INSURANCE_REMOVE_PENDING_DOCUMENTS',
}

interface AddOccupantInsurancesAction {
    type: InsuranceActions.ADD_OCCUPANT_INSURANCES;
    payload: {
        occupantId: number;
        insurances: Insurance[];
    };
}

interface AddInsuranceAction {
    type: InsuranceActions.ADD_INSURANCE;
    payload: {
        occupantId: number;
        insurance: Insurance;
    };
}

interface EditCoverageDatesAction {
    type: InsuranceActions.EDIT_COVERAGE_DATES;
    payload: {
        occupantId: number;
        insuranceId: number;
        coverageStart: string;
        coverageEnd: string;
    };
}

interface EditInsuranceStatusAction {
    type: InsuranceActions.EDIT_INSURANCE_STATUS;
    payload: {
        occupantId: number;
        insuranceId: number;
        status: InsuranceStatus;
    };
}

interface AddInsuranceDocumentsAction {
    type: InsuranceActions.ADD_INSURANCE_DOCUMENTS;
    payload: {
        insuranceId: number;
        documents: InsuranceDocument[];
    };
}

interface AddInsuranceDocumentAction {
    type: InsuranceActions.ADD_INSURANCE_DOCUMENT;
    payload: {
        insuranceId: number;
        document: InsuranceDocument;
    };
}

interface RemoveInsuranceDocumentAction {
    type: InsuranceActions.REMOVE_INSURANCE_DOCUMENT;
    payload: {
        insuranceId: number;
        documentId: string;
    };
}

interface AddInsuranceNotesAction {
    type: InsuranceActions.ADD_INSURANCE_NOTES;
    payload: {
        insuranceId: number;
        notes: InsuranceNote[];
    };
}

interface AddInsuranceNoteAction {
    type: InsuranceActions.ADD_INSURANCE_NOTE;
    payload: {
        insuranceId: number;
        notes: InsuranceNote;
    };
}

interface AddPendingDocumentsAction {
    type: InsuranceActions.ADD_PENDING_DOCUMENTS;
    payload: {
        insuranceId: number;
        occupantId: number;
        documents: File[];
    };
}

interface AddPendingDocumentAction {
    type: InsuranceActions.ADD_PENDING_DOCUMENT;
    payload: {
        insuranceId: number;
        occupantId: number;
        document: File;
    };
}

interface RemovePendingDocumentAction {
    type: InsuranceActions.REMOVE_PENDING_DOCUMENT;
    payload: {
        insuranceId: number;
        document: File;
    };
}

interface RemovePendingDocumentsAction {
    type: InsuranceActions.REMOVE_PENDING_DOCUMENTS;
    payload: {
        insuranceId: number;
        documents: File[];
    };
}

export type InsuranceActionTypes =
    | AddOccupantInsurancesAction
    | AddInsuranceAction
    | EditCoverageDatesAction
    | EditInsuranceStatusAction
    | AddInsuranceDocumentAction
    | AddInsuranceDocumentsAction
    | RemoveInsuranceDocumentAction
    | AddInsuranceNotesAction
    | AddInsuranceNoteAction
    | AddPendingDocumentsAction
    | AddPendingDocumentAction
    | RemovePendingDocumentAction
    | RemovePendingDocumentsAction;
